module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.38861cba61c66739c145.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto-v15-latin-regular.ttf
// module id = 961
// module chunks = 7